/**
 * An utility class to create query strings
 */
export default class QueryString {
  constructor() {
    this._query = [];
  }

  addValue(name, value) {
    this._query.push(`${name}=${value}`);
  }
  addArray(name, array) {
    if (array.length) this.addValue(name, array.join(','));
  }
  addBoolean(name, boolean) {
    this.addValue(name, boolean ? 'True' : 'False');
  }
  addRange(name, value, range) {
    if (!value || !range) return;

    if (value.min !== range.min) this.addValue(`min_${name}`, value.min);
    if (value.max !== range.max) this.addValue(`max_${name}`, value.max);
  }
  toString() {
    return this._query.length ? '?' + this._query.join('&') : '';
  }
}
